import script from "./EditUnpaidOrderedOrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditUnpaidOrderedOrderModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditUnpaidOrderedOrderModal.vue?vue&type=style&index=0&id=982d4966&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-982d4966"]])

export default __exports__